export default __webpack_public_path__ + "static/media/isqeLogo.b3c53fa8.png";